import { Component, OnInit } from '@angular/core';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-eboiler-bar-chart',
  templateUrl: './eboiler-bar-chart.component.html',
  styleUrls: ['./eboiler-bar-chart.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class EboilerBarChartComponent implements OnInit {

  public barChartParameters: any = [];
  public eboilerBarChartApi = BaseUrlConstantsService.BOILER_PARAMETERS_API;
  // public deviceId: any;
  // public assetId: any;
  // public userID: any;
  public centralLabel = "";
  public canvasWidth = 160;
  public gaugeShow: boolean=false;
  public barchartloading: boolean = true;
  public deviceId : string;
  public clientId: string;
  public subsystemId: string;


  constructor(
    public service: BackendApiService,
  ) { 
    if(localStorage.getItem('role') === 'ADMIN'){
      this.clientId = localStorage.getItem('admin_client_id');
    }
    else if(localStorage.getItem('role') === 'CLIENT'){
      this.clientId = localStorage.getItem('user_id');
    }
    else{
      this.clientId = localStorage.getItem("associated_clientid") === "null" ? localStorage.getItem("user_id"): localStorage.getItem("associated_clientid");
    }
    this.subsystemId =  localStorage.getItem('subsystem_id');
  }
 
  ngOnInit(): void {
    this.getBarDataByID();
  }

  public async getBarDataByID(){

    //Energy Meter Bar Graph (ON/OFF) Status Data. 
    this.service.getDataWithQuery(this.eboilerBarChartApi+'get-bar-parameters/'+ this.clientId + "/" +this.subsystemId).then((sRes) => {
      
        let sensorRes= JSON.parse(JSON.stringify(sRes)).data;
        if(sensorRes.status === 'success'){
          if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

            let response = sensorRes.body;
  
              if (response.sensor != undefined){
  
                if(response.sensor.length != 0){
  
                  let barData= response.sensor;
  
                  for (let i = 0; i < barData.length; i++) {
  
                    this.barChartParameters[i] = {};
  
                    // Assign values to the properties of this.tXformerDigitalParameters[i]
                    this.barChartParameters[i] = barData[i];
                  }
                  //this.barchartloading = false;
                  setTimeout(() => {
                    this.barchartloading = false;
                  }, 1000); 
                }
  
              }
          }
        }else{
          this.service.showError('Something went wrong');
        }
        

      });

      
      
  }

}
